/* eslint-disable no-unused-vars */

import _ from 'lodash';
export const getPendingTaskAndPhotosLength = ({
  pending,
  pendingInspections,
  pendingHseEvents,
  pendingChecks,
  syncFailedAssets,
  pendingEquipment = []
}) => {
  let photos = 0,
    documents = 0,
    workOrder = 0,
    workRequest = 0,
    inspection = 0,
    newEquipmentAssets = 0,
    editedEquipmentAssets = 0,
    hseEvents = 0,
    checks = 0,
    inspectionPhotoCount = 0,
    workOrderPhotoCount = 0,
    workRequestPhotoCount = 0,
    incidentPhotoCount = 0,
    inspectionDocumentCount = 0,
    workOrderDocumentCount = 0,
    workRequestDocumentCount = 0,
    incidentDocumentCount = 0,
    checksPhotoCount = 0,
    checksDocumentCount = 0,
    newEquipmentAssetsIds = [],
    inspectionIds = [],
    editedEquipmentAssetsIds = [],
    workOrderIds = [],
    workRequestIds = [],
    assetChecksIds = [],
    incidentIds = [],
    photoIds = [],
    documentIds = [],
    retryNewEquipmentAssetsCount = 0,
    retryEditedEquipmentAssetsCount = 0,
    retryInspectionCount = 0,
    retryWorkOrderCount = 0,
    retryWorkRequestCount = 0,
    retryIncidentCount = 0,
    retryCheckCount = 0,
    retryDocumentCount = 0,
    retryPhotoCount = 0;

  pending.map((task) => {
    const taskFormDataPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      task?.formData || {}
    );

    let photosDownload = [];
    let documentsDownload = [];

    if (task?.photos?.length || taskFormDataPhotosAndDocuments?.photos?.length) {
      photosDownload = task?.photos?.filter((x) => !_.isEmpty(x?.content)) || [];

      photos += photosDownload?.length || 0;
      photos += taskFormDataPhotosAndDocuments?.photos?.length;

      const photoId = photosDownload?.map((x) => x?.id);
      const formPhotoId = taskFormDataPhotosAndDocuments?.photos?.map((x) => x?.id) || [];
      photoIds.push(...photoId);
      photoIds.push(...formPhotoId);
    }

    if (task?.documents?.length || taskFormDataPhotosAndDocuments?.documents?.length) {
      documentsDownload = task?.documents?.filter((x) => !_.isEmpty(x?.content)) || [];

      documents += documentsDownload?.length || 0;
      documents += taskFormDataPhotosAndDocuments?.documents?.length;

      const documentId = documentsDownload?.map((x) => x?.id);
      const formDocumentId = taskFormDataPhotosAndDocuments?.documents?.map((x) => x?.id) || [];
      documentIds.push(...documentId);
      documentIds.push(...formDocumentId);
    }

    if (!task?.newWorkRequest) {
      ++workOrder;
      workOrderPhotoCount += photosDownload?.length;
      workOrderPhotoCount += taskFormDataPhotosAndDocuments?.photos?.length || 0;

      workOrderDocumentCount += documentsDownload?.length;
      workOrderIds.push(task.workorderId || task?.id);

      if (task?.failedTask) {
        retryWorkOrderCount++;
        retryPhotoCount += photosDownload?.length;
        retryPhotoCount += taskFormDataPhotosAndDocuments?.photos?.length;

        retryDocumentCount += documentsDownload?.length;
      }
    }
    if (task?.newWorkRequest) {
      ++workRequest;
      workRequestPhotoCount += photosDownload?.length;
      workRequestPhotoCount += taskFormDataPhotosAndDocuments?.photos?.length || 0;

      workRequestDocumentCount += documentsDownload?.length;
      workRequestIds.push(task.id);

      if (task?.failedTask) {
        retryWorkRequestCount++;
        retryPhotoCount += photosDownload?.length;
        retryPhotoCount += taskFormDataPhotosAndDocuments?.photos?.length;

        retryDocumentCount += documentsDownload?.length;
      }
    }

    return task;
  });
  pendingInspections?.map((ins) => {
    const inspectionPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      ins?.formData || {}
    );
    if (ins?.type === 'Inspection') {
      ++inspection;
      inspectionIds.push(ins?.id);
    }
    if (inspectionPhotosAndDocuments?.photos?.length) {
      photos += inspectionPhotosAndDocuments?.photos?.length;
      inspectionPhotoCount += inspectionPhotosAndDocuments?.photos?.length;
      const photoId = inspectionPhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
    }
    if (inspectionPhotosAndDocuments?.documents?.length) {
      documents += inspectionPhotosAndDocuments?.documents?.length;
      inspectionDocumentCount += inspectionPhotosAndDocuments?.documents?.length;
      const documentId = inspectionPhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
    }

    if (ins?.failedTask) {
      retryInspectionCount++;
      retryPhotoCount += inspectionPhotosAndDocuments?.photos?.length;
      retryDocumentCount += inspectionPhotosAndDocuments?.documents?.length;
    }
    return ins;
  });

  pendingChecks?.map((check) => {
    const checksPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      check?.formData || {}
    );

    if (check?.type === 'Check') {
      ++checks;
      assetChecksIds.push(check?.id);
    }
    if (checksPhotosAndDocuments?.photos?.length) {
      photos += checksPhotosAndDocuments?.photos?.length;
      checksPhotoCount += checksPhotosAndDocuments?.photos?.length;
      const photoId = checksPhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
    }
    if (checksPhotosAndDocuments?.documents?.length) {
      documents += checksPhotosAndDocuments?.documents?.length;
      checksDocumentCount += checksPhotosAndDocuments?.documents?.length;
      const documentId = checksPhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
    }

    if (check?.failedTask) {
      retryCheckCount++;
      retryPhotoCount += checksPhotosAndDocuments?.photos?.length;
      retryDocumentCount += checksPhotosAndDocuments?.documents?.length;
    }

    return check;
  });

  pendingHseEvents?.map((hse) => {
    const hsePhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      hse?.formData || {}
    );

    if (hse?.type === 'HSE') {
      ++hseEvents;

      incidentIds.push(hse?.id);
    }
    if (hsePhotosAndDocuments?.photos?.length) {
      photos += hsePhotosAndDocuments?.photos?.length;
      incidentPhotoCount += hsePhotosAndDocuments?.photos?.length;

      const photoId = hsePhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
    }
    if (hsePhotosAndDocuments?.documents?.length) {
      documents += hsePhotosAndDocuments?.documents?.length;
      incidentDocumentCount += hsePhotosAndDocuments?.documents?.length;
      const documentId = hsePhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
    }

    if (hse?.failedTask) {
      retryIncidentCount++;
      retryPhotoCount += hsePhotosAndDocuments?.photos?.length;
      retryDocumentCount += hsePhotosAndDocuments?.documents?.length;
    }

    return hse;
  });

  pendingEquipment?.map((equ) => {
    if (equ?.isNew) {
      ++newEquipmentAssets;
      newEquipmentAssetsIds.push(equ.equipmentId);

      if (equ?.failedTask) {
        ++retryNewEquipmentAssetsCount;
      }
    } else {
      ++editedEquipmentAssets;
      editedEquipmentAssetsIds.push(equ.equipmentId);
      if (equ?.failedTask) {
        ++retryEditedEquipmentAssetsCount;
      }
    }
    return equ;
  });

  return {
    documents,
    photos,
    workOrder,
    workRequest,
    inspection,
    inspectionPhotos: 0,
    hseEvents,
    checks,
    newEquipmentAssets,
    editedEquipmentAssets,
    inspectionPhotoCount,
    workOrderPhotoCount,
    workRequestPhotoCount,
    incidentPhotoCount,
    inspectionDocumentCount,
    workOrderDocumentCount,
    workRequestDocumentCount,
    incidentDocumentCount,
    checksPhotoCount,
    checksDocumentCount,
    failedImageCount: syncFailedAssets?.photos?.length || 0,
    failedDocumentCount: syncFailedAssets?.documents?.length || 0,

    pendingSync:
      workOrder +
      workRequest +
      inspection +
      hseEvents +
      checks +
      newEquipmentAssets +
      editedEquipmentAssets,

    inspectionIds,
    workOrderIds,
    workRequestIds,
    assetChecksIds,
    incidentIds,
    photoIds,
    documentIds,
    newEquipmentAssetsIds,
    editedEquipmentAssetsIds,
    //
    retryInspectionCount,
    retryWorkOrderCount,
    retryWorkRequestCount,
    retryIncidentCount,
    retryCheckCount,
    retryNewEquipmentAssetsCount,
    retryEditedEquipmentAssetsCount,
    retryDocumentCount: retryDocumentCount + syncFailedAssets?.documents?.length || 0,
    retryPhotoCount: retryPhotoCount + syncFailedAssets?.photos?.length || 0
  };
};

const getPhotosAndDocumentsDataFromSelectedInspection = (obj) => {
  const photos = [],
    documents = [];
  let passFailTrue = 0,
    passFailFalse = 0,
    passFailNA = 0;

  const transformNestedObjects = (nestedObj) => {
    for (let key in nestedObj) {
      if (typeof nestedObj[key] === 'object' && nestedObj[key] !== null) {
        if ('photos' in nestedObj[key] && 'documents' in nestedObj[key]) {
          nestedObj[key].photos?.map((photo) => photos.push(photo));
          nestedObj[key].documents?.map((document) => documents.push(document));
        } else if ('photos' in nestedObj[key]) {
          if (nestedObj[key].photos && nestedObj[key]?.photos?.length) {
            nestedObj[key].photos?.map((photo) => photos.push(photo));
          }
        } else if ('documents' in nestedObj[key]) {
          if (nestedObj[key].documents && nestedObj[key].documents?.length) {
            nestedObj[key].documents?.map((document) => documents.push(document));
          }
        } else if ('answer' in nestedObj[key]) {
          if (nestedObj[key]?.answer === 'true') ++passFailTrue;
          if (nestedObj[key]?.answer === 'false') ++passFailFalse;
          if (nestedObj[key]?.answer === 'NA') ++passFailNA;
        }
      }
    }
  };
  // const transformWorkOrder = (a) => {
  //   for (let i = 0; i < a.length; i++) {
  //     let item = a[i];
  //     item?.photo?.map((photo) => photos.push(photo));
  //     item?.document?.map((document) => documents.push(document));
  //   }
  // };

  for (let key in obj) {
    // if (key === 'work order') {
    //   const a = obj[key];
    //   for (let key1 in a) {
    //     transformWorkOrder(a[key1]);
    //   }
    // } else
    if (!key.includes('ut information-')) transformNestedObjects(obj[key]);
  }

  return {
    photos,
    documents,
    passFailTrue,
    passFailNA,
    passFailFalse
  };
};
